import type { View } from 'api/views/types';

export interface ViewDefinitionTransformer<ViewDefinitionT, ViewDefinitionR> {
  from: (viewDefinition: ViewDefinitionT) => ViewDefinitionR;
  to: (viewDefinition: ViewDefinitionR) => ViewDefinitionT;
}

export interface ViewTransformer<ViewDefinitionT, ViewDefinitionR> {
  from: (viewDefinition: View<ViewDefinitionT>) => View<ViewDefinitionR>;
  to: (viewDefinition: View<ViewDefinitionR>) => View<ViewDefinitionT>;
}

export const defaultViewDefinitionTransformer = {
  from: <ViewDefinitionT, ViewDefinitionR>(
    viewDefinition: ViewDefinitionT,
  ): ViewDefinitionR => viewDefinition as unknown as ViewDefinitionR,
  to: <ViewDefinitionT, ViewDefinitionR>(
    viewDefinition: ViewDefinitionR,
  ): ViewDefinitionT => viewDefinition as unknown as ViewDefinitionT,
};

export const getViewTranformer = <ViewDefinitionT, ViewDefinitionR>(
  viewDefinitionTransformer: ViewDefinitionTransformer<
    ViewDefinitionT,
    ViewDefinitionR
  >,
): ViewTransformer<ViewDefinitionT, ViewDefinitionR> => ({
  from: ({
    viewDefinition,
    ...rest
  }: View<ViewDefinitionT>): View<ViewDefinitionR> => ({
    viewDefinition: viewDefinitionTransformer.from(viewDefinition),
    ...rest,
  }),
  to: ({
    viewDefinition,
    ...rest
  }: View<ViewDefinitionR>): View<ViewDefinitionT> => ({
    viewDefinition: viewDefinitionTransformer.to(viewDefinition),
    ...rest,
  }),
});
